import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import PublicHeader from '../components/PublicHeader';

const AGB = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader title="AGB" showBackButton={false} />

      <div className="container mx-auto px-4 py-12">
        <Link to="/">
          <Button variant="outline" className="mb-8 border-[#2C3E50] hover:bg-[#FDB913] hover:text-[#1a1a1a]">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Zurück zur Startseite
          </Button>
        </Link>

        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <h1 className="text-4xl font-bold text-[#2C3E50] mb-8">Allgemeine Geschäftsbedingungen (AGB)</h1>
          
          <div className="space-y-8 text-gray-700">
            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">§ 1 Geltungsbereich</h2>
              <p>
                Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge über die Vermietung von Maschinen und Fahrzeugen zwischen Hogir Acar (nachfolgend "Vermieter") und dem Mieter.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">§ 2 Vertragsschluss</h2>
              <p className="mb-3">
                1. Der Mietvertrag kommt durch die Annahme der Anfrage durch den Vermieter zustande.
              </p>
              <p className="mb-3">
                2. Eine Anfrage des Mieters stellt ein verbindliches Angebot dar, das der Vermieter innerhalb von 7 Tagen annehmen kann.
              </p>
              <p>
                3. Der Vermieter behält sich vor, Anfragen ohne Angabe von Gründen abzulehnen.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">§ 3 Mietpreise und Zahlungsbedingungen</h2>
              <p className="mb-3">
                1. Die Mietpreise verstehen sich inklusive der gesetzlichen Mehrwertsteuer.
              </p>
              <p className="mb-3">
                2. Die Miete ist bei Übergabe des Mietobjekts fällig, sofern nicht anders vereinbart.
              </p>
              <p>
                3. Bei verspäteter Zahlung ist der Vermieter berechtigt, Verzugszinsen in Höhe von 5% über dem Basiszinssatz zu berechnen.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">§ 4 Kaution</h2>
              <p className="mb-3">
                1. Der Mieter ist verpflichtet, bei Vertragsschluss eine angemessene Kaution zu hinterlegen.
              </p>
              <p className="mb-3">
                2. Die Höhe der Kaution richtet sich nach dem gemieteten Objekt und wird bei Vertragsschluss festgelegt.
              </p>
              <p>
                3. Die Kaution wird nach ordnungsgemäßer Rückgabe und Prüfung des Mietobjekts vollständig erstattet.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">§ 5 Pflichten des Mieters</h2>
              <p className="mb-3">
                1. Der Mieter ist verpflichtet, die gemieteten Fahrzeuge und Maschinen pfleglich zu behandeln und bestimmungsgemäß zu verwenden.
              </p>
              <p className="mb-3">
                2. Der Mieter darf das Mietobjekt nicht ohne schriftliche Zustimmung des Vermieters an Dritte weitergeben.
              </p>
              <p className="mb-3">
                3. Der Mieter muss über die erforderlichen Berechtigungen (z.B. Führerschein) verfügen.
              </p>
              <p>
                4. Schäden und Mängel sind dem Vermieter unverzüglich anzuzeigen.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">§ 6 Haftung des Mieters</h2>
              <p className="mb-3">
                1. Der Mieter haftet für alle Schäden, die durch unsachgemäße Nutzung oder Nichtbeachtung der Bedienungsanleitung entstehen.
              </p>
              <p className="mb-3">
                2. Bei schuldhafter Beschädigung oder Verlust des Mietobjekts trägt der Mieter die vollen Kosten für Reparatur oder Ersatz.
              </p>
              <p>
                3. Der Mieter haftet für Verstöße gegen gesetzliche Vorschriften während der Mietzeit.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">§ 7 Versicherung</h2>
              <p className="mb-3">
                1. Alle Fahrzeuge sind vollkaskoversichert.
              </p>
              <p className="mb-3">
                2. Die Selbstbeteiligung im Schadensfall trägt der Mieter, sofern nicht anders vereinbart.
              </p>
              <p>
                3. Zusatzversicherungen können optional abgeschlossen werden.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">§ 8 Rückgabe und verspätete Rückgabe</h2>
              <p className="mb-3">
                1. Das Mietobjekt ist zum vereinbarten Zeitpunkt in ordnungsgemäßem Zustand zurückzugeben.
              </p>
              <p className="mb-3">
                2. Bei verspäteter Rückgabe ohne vorherige Abstimmung kann ein zusätzlicher Tagessatz sowie eine Vertragsstrafe berechnet werden.
              </p>
              <p>
                3. Bei Rückgabe muss das Mietobjekt im gleichen Zustand sein wie bei Übergabe (normale Abnutzung ausgenommen).
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">§ 9 Haftung des Vermieters</h2>
              <p className="mb-3">
                1. Der Vermieter haftet nicht für Folgeschäden oder Nutzungsausfälle, die durch Mängel am Mietobjekt entstehen.
              </p>
              <p className="mb-3">
                2. Die Haftung des Vermieters ist auf Vorsatz und grobe Fahrlässigkeit beschränkt.
              </p>
              <p>
                3. Der Vermieter übernimmt keine Gewährleistung für die Eignung des Mietobjekts für einen bestimmten Zweck.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">§ 10 Kündigung</h2>
              <p className="mb-3">
                1. Beide Vertragsparteien können den Mietvertrag aus wichtigem Grund fristlos kündigen.
              </p>
              <p>
                2. Ein wichtiger Grund liegt insbesondere vor bei Zahlungsverzug, Vertragsverletzungen oder unsachgemäßer Behandlung des Mietobjekts.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#2C3E50] mb-4">§ 11 Schlussbestimmungen</h2>
              <p className="mb-3">
                1. Es gilt das Recht der Bundesrepublik Deutschland.
              </p>
              <p className="mb-3">
                2. Gerichtsstand ist Wittlich, sofern der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen ist.
              </p>
              <p className="mb-3">
                3. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
              </p>
              <p>
                4. Änderungen und Ergänzungen dieser AGB bedürfen der Schriftform.
              </p>
            </div>

            <div className="bg-[#FDB913]/10 p-6 rounded-lg border-l-4 border-[#FDB913] mt-8">
              <p className="font-semibold text-[#2C3E50]">
                Stand: Januar 2025
              </p>
              <p className="mt-2">
                Hogir Acar<br />
                Breslauer Str. 21<br />
                54516 Wittlich
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AGB;